const Socials = () => {
  const Linkedin = (props) => {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-white border border-white rounded-md p-1 hover:bg-white hover:text-black transition-all duration-150 ease-in-out"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.98292 7.19701C6.19132 7.19701 7.17092 6.21741 7.17092 5.00901C7.17092 3.80062 6.19132 2.82101 4.98292 2.82101C3.77452 2.82101 2.79492 3.80062 2.79492 5.00901C2.79492 6.21741 3.77452 7.19701 4.98292 7.19701Z"
            fill="currentColor"
          />
          <path
            d="M9.23722 8.85499V20.994H13.0062V14.991C13.0062 13.407 13.3042 11.873 15.2682 11.873C17.2052 11.873 17.2292 13.684 17.2292 15.091V20.995H21.0002V14.338C21.0002 11.068 20.2962 8.55499 16.4742 8.55499C14.6392 8.55499 13.4092 9.56199 12.9062 10.515H12.8552V8.85499H9.23722ZM3.09521 8.85499H6.87022V20.994H3.09521V8.85499Z"
            fill="currentColor"
          />
        </svg>
      </a>
    );
  };
  const Instagram = (props) => {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-white border border-white rounded-md p-1 hover:bg-white hover:text-black transition-all duration-150 ease-in-out"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9471 8.30499C20.937 7.54761 20.7952 6.79776 20.5281 6.08899C20.2964 5.49114 19.9426 4.94819 19.4892 4.49482C19.0359 4.04145 18.4929 3.68764 17.8951 3.45599C17.1954 3.19334 16.4562 3.05133 15.7091 3.03599C14.7471 2.99299 14.4421 2.98099 12.0001 2.98099C9.55807 2.98099 9.24507 2.98099 8.29007 3.03599C7.54323 3.05144 6.80442 3.19346 6.10507 3.45599C5.50713 3.68748 4.96409 4.04123 4.5107 4.49462C4.05732 4.94801 3.70356 5.49105 3.47207 6.08899C3.2089 6.78812 3.06719 7.5271 3.05307 8.27399C3.01007 9.23699 2.99707 9.54199 2.99707 11.984C2.99707 14.426 2.99707 14.738 3.05307 15.694C3.06807 16.442 3.20907 17.18 3.47207 17.881C3.70395 18.4787 4.05797 19.0216 4.51151 19.4748C4.96505 19.928 5.50813 20.2816 6.10607 20.513C6.8035 20.7862 7.54244 20.9384 8.29107 20.963C9.25407 21.006 9.55907 21.019 12.0011 21.019C14.4431 21.019 14.7561 21.019 15.7111 20.963C16.4582 20.9483 17.1974 20.8066 17.8971 20.544C18.4948 20.3121 19.0376 19.9582 19.4909 19.5048C19.9442 19.0515 20.2982 18.5087 20.5301 17.911C20.7931 17.211 20.9341 16.473 20.9491 15.724C20.9921 14.762 21.0051 14.457 21.0051 12.014C21.0031 9.57199 21.0031 9.26199 20.9471 8.30499ZM11.9941 16.602C9.44007 16.602 7.37107 14.533 7.37107 11.979C7.37107 9.42499 9.44007 7.35599 11.9941 7.35599C13.2202 7.35599 14.396 7.84305 15.263 8.71003C16.13 9.57701 16.6171 10.7529 16.6171 11.979C16.6171 13.2051 16.13 14.381 15.263 15.2479C14.396 16.1149 13.2202 16.602 11.9941 16.602ZM16.8011 8.26299C16.6595 8.26312 16.5192 8.23533 16.3884 8.1812C16.2575 8.12707 16.1386 8.04767 16.0385 7.94754C15.9384 7.84741 15.859 7.72852 15.8049 7.59768C15.7507 7.46683 15.7229 7.32659 15.7231 7.18499C15.7231 7.04349 15.7509 6.90337 15.8051 6.77265C15.8592 6.64192 15.9386 6.52314 16.0387 6.42308C16.1387 6.32302 16.2575 6.24366 16.3882 6.18951C16.519 6.13536 16.6591 6.10749 16.8006 6.10749C16.9421 6.10749 17.0822 6.13536 17.2129 6.18951C17.3436 6.24366 17.4624 6.32302 17.5625 6.42308C17.6625 6.52314 17.7419 6.64192 17.7961 6.77265C17.8502 6.90337 17.8781 7.04349 17.8781 7.18499C17.8781 7.78099 17.3961 8.26299 16.8011 8.26299Z"
            fill="currentColor"
          />
          <path
            d="M11.9942 14.982C13.6527 14.982 14.9972 13.6375 14.9972 11.979C14.9972 10.3205 13.6527 8.97601 11.9942 8.97601C10.3357 8.97601 8.99121 10.3205 8.99121 11.979C8.99121 13.6375 10.3357 14.982 11.9942 14.982Z"
            fill="currentColor"
          />
        </svg>
      </a>
    );
  };
  const Facebook = (props) => {
    return (
      <a
        href={props.href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-white border border-white rounded-md p-1 hover:bg-white hover:text-black transition-all duration-150 ease-in-out"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.397 20.997V12.801H16.162L16.573 9.59199H13.397V7.54799C13.397 6.62199 13.655 5.98799 14.984 5.98799H16.668V3.12699C15.8487 3.03918 15.0251 2.99678 14.201 2.99999C11.757 2.99999 10.079 4.49199 10.079 7.23099V9.58599H7.33203V12.795H10.085V20.997H13.397Z"
            fill="currentColor"
          />
        </svg>
      </a>
    );
  };
  if (window.location.href.includes("harkinsandvickers")) {
    return (
      <div className="flex gap-2 absolute bottom-4">
        <Facebook href="https://www.facebook.com/Harkins-Vickers-Electrical-Solutions-116620168025108/" />
        <Instagram href="https://www.instagram.com/harkinsandvickerselectrical/" />
        <Linkedin href="https://www.linkedin.com/company/harkins-vickers-electrical-solutions/" />
      </div>
    );
  } else {
    return (
      <div className="flex gap-2 absolute bottom-4">
        <Facebook href="https://www.facebook.com/keithgunnelectrical" />
        <Instagram href="https://instagram.com/keithgunnelectrical" />
        <Linkedin href="https://uk.linkedin.com/company/keith-gunn-electrical-solutions-ltd" />
      </div>
    );
  }
};

export default Socials;
